"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var CustomPropTypes = _interopRequireWildcard(require("../../../constants/PropTypes"));

var _immutable = _interopRequireDefault(require("immutable"));

var _q = _interopRequireDefault(require("q"));

var _spread = _interopRequireDefault(require("hs-promise-utils/spread"));

var _memoize = _interopRequireDefault(require("hs-lodash/memoize"));

var _misc = require("HubStyleTokens/misc");

var _unescapedText = _interopRequireDefault(require("I18n/utils/unescapedText"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _SyntheticEvent = _interopRequireDefault(require("UIComponents/core/SyntheticEvent"));

var _AbstractTextElement = _interopRequireDefault(require("UIComponents/elements/AbstractTextElement"));

var _Big = _interopRequireDefault(require("UIComponents/elements/Big"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _UIMediaObject = _interopRequireDefault(require("UIComponents/layout/UIMediaObject"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UITruncateString = _interopRequireDefault(require("UIComponents/text/UITruncateString"));

var _UITypeaheadResultsItem = _interopRequireDefault(require("UIComponents/typeahead/results/UITypeaheadResultsItem"));

var _categoryFeatures = require("ecosystem-marketplace-core/constants/groupTags/categoryFeatures");

var GROUPED_CATEGORIES = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/groupTags/superCategoryGroups"));

var _useDebounceValue = require("ecosystem-marketplace-core/utils/hooks/useDebounceValue");

var _i18n = require("ecosystem-marketplace-core/utils/i18n");

var _offerings = require("ecosystem-marketplace-core/utils/offerings");

var ecosystemClient = _interopRequireWildcard(require("../../../clients/ecosystemClient"));

var _superCategoryOrder = _interopRequireDefault(require("../../../constants/superCategoryOrder"));

var FilterKey = _interopRequireWildcard(require("../../../constants/search/FilterKey"));

var _StorefrontFilters = _interopRequireDefault(require("../../../records/StorefrontFilters"));

var _env = require("../../../utils/env");

var _usePrevious = require("../../../utils/hooks/usePrevious");

var _search = require("../../../utils/search");

var _PieSyncConnectorIcon = _interopRequireDefault(require("../../common/PieSyncConnectorIcon"));

var _StorefrontUsageTrackerContext = _interopRequireDefault(require("../../../context/StorefrontUsageTrackerContext"));

var _InputHighlighter = _interopRequireDefault(require("./InputHighlighter"));

var _SearchSelectContext = _interopRequireDefault(require("./SearchSelectContext"));

var _SearchSelectInput = _interopRequireDefault(require("./SearchSelectInput"));

var EMPTY_SET = _immutable.default.Set();

var EMPTY_ORDERED_MAP = _immutable.default.OrderedMap();

var MAX_ICON_WIDTH = 48;
var SEARCH_LENGTH = 5;
var SEE_MORE_OPTION_VALUE = '__SEE_MORE_OPTION__';

var getI18nKey = function getI18nKey(key) {
  return "appMarketplace.storefront.searchSelect." + key;
};

var memoizeCategoryResolver = function memoizeCategoryResolver(superCategory, category) {
  return [superCategory, category].filter(Boolean).join(':');
};

var getCategoryOptions = (0, _memoize.default)(function (searchSuperCategory, searchCategory) {
  if (searchCategory) {
    return EMPTY_SET;
  }

  return _superCategoryOrder.default.reduce(function (final, superCategory) {
    if (searchSuperCategory && searchSuperCategory !== superCategory) {
      return final;
    }

    var categories = Object.values(GROUPED_CATEGORIES[superCategory]);
    return final.withMutations(function (mutableMap) {
      categories.forEach(function (category) {
        if (mutableMap.has(category)) {
          return;
        }

        mutableMap.set(category, {
          text: (0, _unescapedText.default)((0, _i18n.getCategoryI18nKey)(category)),
          value: FilterKey.CATEGORY + ":" + superCategory + ":" + category,
          filterKey: FilterKey.CATEGORY,
          help: !searchSuperCategory ? (0, _unescapedText.default)(getI18nKey('inCategory'), {
            category: (0, _unescapedText.default)((0, _i18n.getSuperCategoryI18nKey)(superCategory))
          }) : null
        });
      });
    });
  }, EMPTY_ORDERED_MAP).toOrderedSet();
}, memoizeCategoryResolver);
var getFeatureOptions = (0, _memoize.default)(function (searchSuperCategory, searchCategory) {
  return _superCategoryOrder.default.reduce(function (final, superCategory) {
    if (searchSuperCategory && searchSuperCategory !== superCategory) {
      return final;
    }

    var categories = Object.values(GROUPED_CATEGORIES[superCategory]).filter(function (category) {
      return searchCategory ? category === searchCategory : true;
    });

    if (!categories.length) {
      return final;
    }

    return final.withMutations(function (mutableMap) {
      categories.forEach(function (category) {
        var features = Object.values(_categoryFeatures.BY_CATEGORY[category]);
        features.forEach(function (feature) {
          if (mutableMap.has(feature)) {
            return;
          }

          mutableMap.set(feature, {
            text: (0, _unescapedText.default)((0, _i18n.getCategoryFeatureI18nKey)(category, feature)),
            value: FilterKey.CATEGORY_FEATURES + ":" + superCategory + ":" + category + ":" + feature,
            filterKey: FilterKey.CATEGORY_FEATURES,
            help: !searchCategory ? (0, _unescapedText.default)(getI18nKey('inCategory'), {
              category: (0, _unescapedText.default)((0, _i18n.getCategoryI18nKey)(category))
            }) : null
          });
        });
      });
    });
  }, EMPTY_ORDERED_MAP).toOrderedSet();
}, memoizeCategoryResolver);

var getMatchingOptions = function getMatchingOptions(input, options) {
  // TODO filter by value?
  return options.filter(function (_ref) {
    var text = _ref.text;
    return !!~_UISelect.default.stripDiacritics(text.toLowerCase()).indexOf(input);
  }).sortBy(function (_ref2) {
    var text = _ref2.text;
    return text;
  }).map(function (option) {
    return (0, _extends2.default)({}, option, {
      dropdownText: _react.default.createElement(_InputHighlighter.default, {
        text: option.text,
        value: input
      })
    });
  }).toArray();
};

var renderOption = function renderOption(option) {
  return _react.default.createElement(_UITypeaheadResultsItem.default, {
    message: true,
    option: option
  });
};

var PieSyncConnectorLinkComponent = function PieSyncConnectorLinkComponent(_ref3) {
  var children = _ref3.children;
  return _react.default.createElement(_AbstractTextElement.default, null, children);
};

var renderAppOptionText = function renderAppOptionText(_ref4, input) {
  var category = _ref4.category,
      companyName = _ref4.companyName,
      iconUrl = _ref4.iconUrl,
      name = _ref4.name,
      nativeId = _ref4.nativeId,
      offeringId = _ref4.offeringId,
      tagline = _ref4.tagline;
  var isPieSyncConnector = (0, _offerings.getIsPieSyncConnector)(nativeId, offeringId);
  return _react.default.createElement(_UIMediaObject.default, {
    itemLeft: _react.default.createElement("div", {
      style: {
        width: MAX_ICON_WIDTH
      }
    }, _react.default.createElement(_UIImage.default, {
      src: iconUrl
    }))
  }, _react.default.createElement("div", {
    className: "m-bottom-1"
  }, _react.default.createElement(_Big.default, {
    className: "display-block"
  }, _react.default.createElement("b", null, name), isPieSyncConnector && _react.default.createElement(_PieSyncConnectorIcon.default, {
    className: "m-left-2",
    linkComponent: PieSyncConnectorLinkComponent,
    size: 20
  })), _react.default.createElement(_Small.default, {
    use: "help"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: getI18nKey('companyName'),
    options: {
      companyName: companyName
    }
  }))), _react.default.createElement("div", {
    className: "m-bottom-2"
  }, _react.default.createElement(_UITruncateString.default, null, _react.default.createElement(_InputHighlighter.default, {
    text: tagline,
    value: input
  }))), _react.default.createElement(_Small.default, {
    use: "help"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: getI18nKey('inCategory'),
    options: {
      category: (0, _unescapedText.default)((0, _i18n.getCategoryI18nKey)(category))
    }
  })));
};

var SearchSelect = function SearchSelect(_ref5) {
  var _ref6;

  var activeCategory = _ref5.activeCategory,
      activeSuperCategory = _ref5.activeSuperCategory,
      appIntegrations = _ref5.appIntegrations,
      onAppSelect = _ref5.onAppSelect,
      onCategorySelect = _ref5.onCategorySelect,
      onClear = _ref5.onClear,
      onFeatureSelect = _ref5.onFeatureSelect,
      onFilterSelect = _ref5.onFilterSelect,
      onSubmit = _ref5.onSubmit,
      searchValue = _ref5.searchValue,
      isSticky = _ref5.isSticky;
  var cachedSearchValues = (0, _search.getCachedSearchValues)();

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      clearButtonClicked = _useState2[0],
      setClearButtonClicked = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      isLoading = _useState4[0],
      setIsLoading = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      open = _useState6[0],
      setOpen = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      options = _useState8[0],
      setOptions = _useState8[1];

  var totalOptions = options ? options.length : 0;

  var _useState9 = (0, _react.useState)(0),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      totalAppResults = _useState10[0],
      setTotalAppResults = _useState10[1];

  var _useState11 = (0, _react.useState)(null),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      appsRequest = _useState12[0],
      setAppsRequest = _useState12[1];

  var _useState13 = (0, _react.useState)(new _StorefrontFilters.default((_ref6 = {}, (0, _defineProperty2.default)(_ref6, FilterKey.SUPER_CATEGORY, activeSuperCategory), (0, _defineProperty2.default)(_ref6, FilterKey.CATEGORY, activeCategory), (0, _defineProperty2.default)(_ref6, FilterKey.SEARCH, searchValue), _ref6))),
      _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
      searchFilters = _useState14[0],
      setSearchFilters = _useState14[1];

  var superCategory = searchFilters[FilterKey.SUPER_CATEGORY],
      category = searchFilters[FilterKey.CATEGORY],
      inputValue = searchFilters[FilterKey.SEARCH];
  var debouncedInputValue = (0, _useDebounceValue.useDebounceValue)(inputValue);
  var prevDebouncedInputValue = (0, _usePrevious.usePrevious)(debouncedInputValue);
  var prevOpen = (0, _usePrevious.usePrevious)(open);
  var prevCategory = (0, _usePrevious.usePrevious)(category);
  var prevSuperCategory = (0, _usePrevious.usePrevious)(superCategory);
  var prevActiveCategory = (0, _usePrevious.usePrevious)(activeCategory);
  var prevActiveSuperCategory = (0, _usePrevious.usePrevious)(activeSuperCategory);
  var prevSearchValue = (0, _usePrevious.usePrevious)(searchValue);

  var _useContext = (0, _react.useContext)(_StorefrontUsageTrackerContext.default),
      trackInteraction = _useContext.trackInteraction; // TODO track search term


  var trackSelectItem = (0, _react.useCallback)(function (properties) {
    trackInteraction('select search autofill item', properties, 'storefront-select-search-autofill-item');
  }, [trackInteraction]);

  var handleResetOptions = function handleResetOptions() {
    setOptions(null);
    setTotalAppResults(0);
    setAppsRequest(null);
  };

  var handleSetInputValue = (0, _react.useCallback)(function (value) {
    setSearchFilters(searchFilters.set(FilterKey.SEARCH, value));
  }, [searchFilters]);
  var handleUpdateSearchFilters = (0, _react.useCallback)(function (newSuperCategory, newCategory) {
    var updatedSearchFilters = searchFilters.withMutations(function (mutableFilters) {
      mutableFilters.set(FilterKey.SUPER_CATEGORY, newSuperCategory).set(FilterKey.CATEGORY, newCategory);
    });
    setSearchFilters(updatedSearchFilters);

    if (inputValue && !open) {
      onSubmit(updatedSearchFilters);
    } else {
      onCategorySelect(newSuperCategory, newCategory);
    }

    if (open && !inputValue) {
      setOpen(false);
    }
  }, [inputValue, onCategorySelect, onSubmit, open, searchFilters]);
  var menuStyles = (0, _react.useMemo)(function () {
    var minHeight = 0;

    if (totalAppResults && totalOptions) {
      var help = options[0].help;
      var computedAppResultsHeight = 95 * Math.min(totalAppResults, SEARCH_LENGTH) + (help ? 60 : 40);

      if (totalOptions === 1) {
        minHeight = computedAppResultsHeight;
      } else {
        minHeight = Math.max(computedAppResultsHeight, 300);
      }
    }

    return {
      minHeight: minHeight
    };
  }, [options, totalAppResults, totalOptions]);
  var defaultOptions = (0, _react.useMemo)(function () {
    if (!cachedSearchValues.length) {
      return [];
    }

    return [{
      text: (0, _unescapedText.default)(getI18nKey('groupLabels.recentSearches')),
      options: cachedSearchValues.map(function (value) {
        return {
          text: value,
          value: value,
          cachedSearchValue: true,
          isSpecial: true
        };
      })
    }];
  }, [cachedSearchValues]);
  var integrationOptions = (0, _react.useMemo)(function () {
    return appIntegrations.map(function (integration) {
      return {
        text: integration,
        value: FilterKey.INTEGRATIONS + ":" + integration,
        filterKey: FilterKey.INTEGRATIONS
      };
    });
  }, [appIntegrations]);
  var getMatchingApps = (0, _react.useCallback)(function (input) {
    if (appsRequest && appsRequest.readyState !== 4) {
      appsRequest.abort();
    }

    var queries = [searchFilters.toSearchQuery({
      length: SEARCH_LENGTH,
      nextSearchMaxTrigger: 1
    }), searchFilters.toAllCategories().toSearchQuery({
      length: SEARCH_LENGTH
    })];
    setTotalAppResults(0);
    return ecosystemClient.searchMulti(queries, {
      withXhr: function withXhr(xhr) {
        setAppsRequest(xhr);
      }
    }).then(function (_ref7) {
      var _ref8 = (0, _slicedToArray2.default)(_ref7, 2),
          primary = _ref8[0],
          _ref8$ = _ref8[1],
          supplemental = _ref8$ === void 0 ? {
        items: [],
        total: 0
      } : _ref8$;

      var primaryResults = primary.items,
          primaryResultsTotal = primary.total;
      var supplementalResults = supplemental.items,
          supplementalResultsTotal = supplemental.total;
      var showSupplementalResults = (category || superCategory) && !primaryResultsTotal && supplementalResultsTotal;

      var _ref9 = showSupplementalResults ? [supplementalResults, supplementalResultsTotal] : [primaryResults, primaryResultsTotal],
          _ref10 = (0, _slicedToArray2.default)(_ref9, 2),
          results = _ref10[0],
          resultsTotal = _ref10[1];

      if (!resultsTotal) {
        return null;
      }

      var appsOptions = results.map(function (result) {
        return {
          value: "" + result.id,
          text: result.name,
          slug: result.slug,
          category: result.category,
          title: result.name,
          dropdownText: renderAppOptionText(result, input)
        };
      });

      if (resultsTotal > SEARCH_LENGTH) {
        appsOptions.push({
          dropdownText: _react.default.createElement(_UILink.default, null, _react.default.createElement(_FormattedMessage.default, {
            message: getI18nKey('seeMoreText'),
            options: {
              count: resultsTotal
            }
          })),
          isSpecial: true,
          title: '',
          value: SEE_MORE_OPTION_VALUE
        });
      }

      setTotalAppResults(resultsTotal);
      return {
        text: (0, _unescapedText.default)(getI18nKey('groupLabels.apps')),
        options: appsOptions,
        help: showSupplementalResults ? _react.default.createElement("span", {
          style: {
            fontWeight: _misc.WEB_FONT_MEDIUM_WEIGHT
          }
        }, _react.default.createElement(_FormattedMessage.default, {
          message: getI18nKey('noResultsText.category'),
          options: {
            category: (0, _unescapedText.default)(category ? (0, _i18n.getCategoryI18nKey)(category) : (0, _i18n.getSuperCategoryI18nKey)(superCategory))
          }
        })) : null
      };
    });
  }, [appsRequest, category, searchFilters, superCategory]);
  var getMatchingCategories = (0, _react.useCallback)(function (input) {
    return _q.default.Promise.resolve(getMatchingOptions(input, getCategoryOptions(superCategory, category))).then(function (matches) {
      if (!matches.length) {
        return null;
      }

      return {
        text: (0, _unescapedText.default)(getI18nKey('groupLabels.categories')),
        options: matches
      };
    });
  }, [category, superCategory]);
  var getMatchingFeatures = (0, _react.useCallback)(function (input) {
    return _q.default.Promise.resolve(getMatchingOptions(input, getFeatureOptions(superCategory, category))).then(function (matches) {
      if (!matches.length) {
        return null;
      }

      return {
        text: (0, _unescapedText.default)(getI18nKey('groupLabels.features')),
        options: matches
      };
    });
  }, [category, superCategory]);
  var getMatchingIntegrations = (0, _react.useCallback)(function (input) {
    return _q.default.Promise.resolve(getMatchingOptions(input, integrationOptions)).then(function (matches) {
      if (!matches.length) {
        return null;
      }

      return {
        text: (0, _unescapedText.default)(getI18nKey('groupLabels.integrations')),
        options: matches
      };
    });
  }, [integrationOptions]);
  var handleSubmit = (0, _react.useCallback)(function (value) {
    setOpen(false);
    onSubmit(searchFilters.set(FilterKey.SEARCH, value));
    (0, _search.cacheSearchValue)(value);
  }, [onSubmit, searchFilters]);
  var handleInputKeyDown = (0, _react.useCallback)(function (evt) {
    var key = evt.key,
        _value = evt.target.value;

    var value = _value.trim();

    if (value && key === 'Enter') {
      evt.preventDefault();
      handleSubmit(value);
      trackInteraction('submit search', {
        search: value,
        searchLength: value.length
      });
    }
  }, [handleSubmit, trackInteraction]);
  var handleInputChange = (0, _react.useCallback)(function (evt) {
    var value = evt.target.value;

    if (!value.trim()) {
      handleSetInputValue('');

      if (searchValue) {
        onClear();
      }
    } else {
      handleSetInputValue(value);
    } // TODO related to https://git.hubteam.com/HubSpot/UIComponents/issues/7365


    if (evt instanceof _SyntheticEvent.default.constructor) {
      setClearButtonClicked(true);
    }
  }, [handleSetInputValue, onClear, searchValue]);
  var handleSearch = (0, _react.useCallback)(function (input) {
    setOptions([]);
    setIsLoading(true);
    (0, _spread.default)([getMatchingApps(input), getMatchingCategories(input), getMatchingFeatures(input), getMatchingIntegrations(input)], function (appsOptionGroup, categoriesOptionGroup, featuresOptionGroup, integrationsOptionGroup) {
      setIsLoading(false);
      setOptions([appsOptionGroup, categoriesOptionGroup, featuresOptionGroup, integrationsOptionGroup].filter(Boolean));
    }).done();
  }, [getMatchingApps, getMatchingCategories, getMatchingFeatures, getMatchingIntegrations]);
  (0, _react.useEffect)(function () {
    if (debouncedInputValue !== prevDebouncedInputValue || open !== prevOpen) {
      if (open && debouncedInputValue) {
        handleSearch(debouncedInputValue);
      } else {
        handleResetOptions();
      }
    }
  }, [debouncedInputValue, handleSearch, open, prevDebouncedInputValue, prevOpen]);
  (0, _react.useEffect)(function () {
    if (category !== prevCategory || superCategory !== prevSuperCategory) {
      if (open && debouncedInputValue) {
        handleSearch(debouncedInputValue);
      } else {
        handleResetOptions();
      }
    }
  }, [category, debouncedInputValue, handleSearch, open, prevCategory, prevSuperCategory, superCategory]);
  (0, _react.useEffect)(function () {
    if (activeCategory !== prevActiveCategory || activeSuperCategory !== prevActiveSuperCategory || searchValue !== prevSearchValue) {
      if (activeCategory !== category || activeSuperCategory !== superCategory) {
        setOpen(false);
      }

      setSearchFilters(searchFilters.withMutations(function (mutableFilters) {
        mutableFilters.set(FilterKey.SUPER_CATEGORY, activeSuperCategory).set(FilterKey.CATEGORY, activeCategory).set(FilterKey.SEARCH, open ? inputValue : searchValue);
      }));
    }
  }, [activeCategory, activeSuperCategory, category, inputValue, open, prevActiveCategory, prevActiveSuperCategory, prevSearchValue, searchFilters, searchValue, superCategory]);
  (0, _react.useEffect)(function () {
    if ((0, _env.debug)('search-select')) {
      console.groupCollapsed('storefront search select');
      console.log('activeSuperCategory:', activeSuperCategory);
      console.log('superCategory:', superCategory);
      console.log('activeCategory:', activeCategory);
      console.log('category:', category);
      console.log('inputValue:', inputValue);
      console.log('isLoading:', isLoading);
      console.log('open:', open);
      console.log('options:', options);
      console.log('totalAppResults:', totalAppResults);
      console.groupEnd();
    }
  }, [activeCategory, activeSuperCategory, totalAppResults, category, isLoading, options, superCategory, open, inputValue]);
  return _react.default.createElement(_SearchSelectContext.default.Provider, {
    value: {
      superCategory: superCategory,
      category: category,
      isSticky: isSticky,
      updateSearchFilters: handleUpdateSearchFilters
    }
  }, _react.default.createElement(_UISelect.default, {
    anchorType: "input",
    cache: false,
    filterOptions: false,
    inputComponent: _SearchSelectInput.default,
    inputValue: inputValue,
    isLoading: isLoading,
    menuStyle: menuStyles,
    onInputKeyDown: handleInputKeyDown,
    onInputValueChange: function onInputValueChange(evt) {
      return handleInputChange(evt);
    },
    onOpenChange: function onOpenChange(_ref11) {
      var value = _ref11.target.value;

      if (clearButtonClicked) {
        setClearButtonClicked(false);
        return;
      }

      setOpen(value);
    },
    onSelectedOptionChange: function onSelectedOptionChange(_ref12) {
      var option = _ref12.target.value;
      var value = option.value,
          filterKey = option.filterKey,
          cachedSearchValue = option.cachedSearchValue;

      if (filterKey) {
        var _value$split = value.split(':'),
            _value$split2 = (0, _toArray2.default)(_value$split),
            filterValues = _value$split2.slice(1);

        switch (filterKey) {
          case FilterKey.CATEGORY:
            {
              var _filterValues = (0, _slicedToArray2.default)(filterValues, 2),
                  optionSuperCategory = _filterValues[0],
                  optionCategory = _filterValues[1];

              onCategorySelect(optionSuperCategory, optionCategory);
              trackSelectItem({
                type: 'category',
                value: optionCategory
              });
              break;
            }

          case FilterKey.CATEGORY_FEATURES:
            {
              var _filterValues2 = (0, _slicedToArray2.default)(filterValues, 3),
                  _optionSuperCategory = _filterValues2[0],
                  _optionCategory = _filterValues2[1],
                  optionFeature = _filterValues2[2];

              onFeatureSelect(_optionSuperCategory, _optionCategory, optionFeature);
              trackSelectItem({
                type: 'feature',
                value: optionFeature
              });
              break;
            }

          case FilterKey.INTEGRATIONS:
            {
              var filterValue = filterValues[0];
              onFilterSelect(filterKey, filterValue);
              trackSelectItem({
                type: 'integration',
                value: filterValue
              });
              break;
            }

          default:
            break;
        }

        return;
      }

      if (cachedSearchValue) {
        handleSubmit(value);
        trackSelectItem({
          type: 'recent search',
          value: value
        });
        return;
      }

      if (value === SEE_MORE_OPTION_VALUE) {
        handleSubmit(inputValue);
        trackSelectItem({
          type: 'see more',
          totalResults: totalAppResults
        });
        return;
      }

      var slug = option.slug,
          appCategory = option.category;
      onAppSelect(slug, appCategory);
      trackSelectItem({
        type: 'app',
        value: slug
      });
    },
    open: open,
    options: options || defaultOptions,
    optionRenderer: renderOption,
    value: null
  }));
};

SearchSelect.propTypes = {
  activeCategory: CustomPropTypes.category,
  activeSuperCategory: CustomPropTypes.superCategory,
  appIntegrations: _reactImmutableProptypes.default.orderedSet.isRequired,
  onAppSelect: _propTypes.default.func.isRequired,
  onCategorySelect: _propTypes.default.func.isRequired,
  onClear: _propTypes.default.func.isRequired,
  onFeatureSelect: _propTypes.default.func.isRequired,
  onFilterSelect: _propTypes.default.func.isRequired,
  onSubmit: _propTypes.default.func.isRequired,
  searchValue: _propTypes.default.string,
  isSticky: _propTypes.default.bool
};
var _default = SearchSelect;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/storefront/search/SearchSelect.js
// module id = 754
// module chunks = 209 210 211 212